module.exports = __webpack_public_path__ + "img/specific.b3c3353e.svg";